module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-load flex"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.hide
    }
  }, [_c('i', {
    staticClass: "iconfont icon-guanbi"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "flex-1 text-l"
  }, [_vm._v("快买酒")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toDownLoad
    }
  }, [_vm._v("下载APP")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../UserCenter/about/logo.jpg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-074d2082"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownLoad/DownLoad.vue
// module id = 512
// module chunks = 0